export default "__VITE_ASSET__BkGiSm9VMCHvyaVi0Ppa3A__"